import React from 'react';

export default React.createContext({
  activeTabId: '',
  onTabChange: Function.prototype,
  disableSwipeableContent: false,
  skipRenderInactiveContent: false,
  isSwipePrevented: false,
  setSwipePrevented: Function.prototype,
  activeTabManager: {},
  scrollContainerRef: null,
});
